export default __webpack_public_path__ + "static/media/gwn22.a6442ca6.webp";